import { createSelector } from 'reselect';
import { IProfilesState } from './types';

export const selectLoadedState = (state: IProfilesState) => state.loaded;
export const selectProfiles = (state: IProfilesState) => state.profiles;
export const selectProfileTypes = (state: IProfilesState) => state.profileTypes;
export const selectSelectedProfile = (state: IProfilesState) => state.selectedProfile;
export const selectSyncError = (state: IProfilesState) => state.error;
export const selectSyncState = (state: IProfilesState) => state.syncing;

export const selectIndexedProfiles = createSelector(selectProfiles, (profiles) =>
  profiles.reduce((indexed, profile) => {
    if (profile.externalId) {
      indexed[profile.externalId] = profile;
    }
    return indexed;
  }, {})
);
export const selectProfile = createSelector(
  [selectIndexedProfiles, (_: IProfilesState, id: string) => id],
  (indexedProfiles, id) => indexedProfiles[id]
);
